import React, { Component } from "react";
import PortfolioCard from "./PortfolioCard";
import Row from "react-bootstrap/Row";
import firebase from "./firebase";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
class PortfolioSection extends Component {
  constructor() {
    super();
    this.state = { Portfolios: [] };
    this.getPortfolios();
  }
  render() {
    return (
      <div className="p-3 mb-2 bg-info text-white">
        <h1 align="center">PORTFOLIO</h1>
        <Row className="justify-content-md-left">
          {this.state.Portfolios.map(portfolio => (
            <Col md="auto" align="center">
              <PortfolioCard
                key={portfolio.id}
                portfolioVal={portfolio}
              ></PortfolioCard>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  getPortfolios = () => {
    var self = this;
    firebase
      .database()
      .ref("/Portfolios/")
      .on("value", function(snapshot) {
        snapshot.forEach(function(item) {
          self.setState({ Portfolios: [...self.state.Portfolios, item.val()] });
        });
        console.log(self.state.Portfolios);
      });
  };
}

export default PortfolioSection;
